export const OnCreateChatBlitzarByActivityId = /* GraphQL */ `
  subscription OnCreateChatBlitzarByActivityId($activity_id: String!) {
    onCreateChatBlitzarByActivityId(activity_id: $activity_id) {
      id
      name
      message
    }
  }
`;

export const OnCreateChatBlitzarByUserId = /* GraphQL */ `
  subscription OnCreateChatBlitzarByUserId($user_id: String!) {
    onCreateChatBlitzarByUserId(user_id: $user_id) {
      id
      name
      message
    }
  }
`;

export const OnCreateChatBlitzarByEventId = /* GraphQL */ `
  subscription OnCreateChatBlitzarByEventId($event_id: String!) {
    onCreateChatBlitzarByEventId(event_id: $event_id) {
      id
      name
      message
    }
  }
`;